module.exports = __webpack_public_path__ + "img/dashiji-2007.a1716a3d.jpg";